<template>
  <div class="loader-wrapper">
      <img src="/img/blue-loader.gif" alt="" class="loader-img">
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    .loader-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 100px 0px;
    }

    .loader-wrapper .loader-img{
        width: 100px;
        height: 100px;
    }
</style>